module.exports = __webpack_public_path__ + "h5/img/integral.35743186.png";